/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerArchivedConfig } from '../../config/header.config';
export interface IHeaderArchivedPluginMethods extends IPluginMethodMap {
  getHeaderArchivedSync(args?: any): any;
}

export class HeaderArchivedPlugin implements IAgentPlugin {
  readonly methods: IHeaderArchivedPluginMethods;

  constructor() {
    this.methods = {
      getHeaderArchivedSync: this.getHeaderArchivedSync.bind(this),
    };
  }

  getHeaderArchivedSync(args?: any) {
    return {
      header: headerArchivedConfig,
    };
  }
}
